import { useState } from "react";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LOCALE_LABELS } from "checkout/ts/locale/labels";
import classnames from "classnames";

import backImageMobile from "./images/CVV-mobile-back.png";
import frontImageMobile from "./images/CVV-mobile-front.png";

interface OwnProps {
    dark?: boolean;
}

export const CvvInfo = ({ dark }: OwnProps) => {
    const { formatMessage } = useIntl();
    const [expanded, setExpanded] = useState(false);

    return (
        <div className="cvv-info">
            <Button
                tabIndex={0}
                aria-labelledby="dropdown_link"
                onClick={() => setExpanded(!expanded)}
                className={classnames("dropdown-button", dark && "dark")}>
                <FontAwesomeIcon className="cvv-chevron" icon={expanded ? faChevronUp : faChevronDown} />

                <p className="cvv-button-text">{formatMessage({ id: LOCALE_LABELS.FORM_CVV_IMAGE_BUTTON })}</p>
            </Button>

            {expanded && (
                <Row className={classnames("container", dark && "dark")}>
                    <Col xs={12} className="column">
                        <img src={backImageMobile} alt="CVV card back" />

                        <p>{formatMessage({ id: LOCALE_LABELS.FORM_CVV_IMAGE_BACK_TEXT })}</p>
                    </Col>

                    <Col xs={12} className="column">
                        <img src={frontImageMobile} alt="CVV card front" />

                        <p>{formatMessage({ id: LOCALE_LABELS.FORM_CVV_IMAGE_FRONT_TEXT })}</p>
                    </Col>
                </Row>
            )}
        </div>
    );
};
